const zh = {
  // layout
  login: {
    login: '登录'
  },
  commons: {
    xiaoai: '小爱',
    admin: '管理员',
    editor: '赵晓编',
    quit: '退出',
    hi: '您好',
    index: '首页',
    userManage: '用户管理',
    share: '分享功能',
    infoManage: '信息管理',
    infoShow: '个人信息',
    infoShow1: '个人信息子菜单1',
    infoShow2: '个人信息子菜单2',
    infoShow3: '个人信息子菜单3',
    infoShow4: '个人信息子菜单4',
    infoShow5: '个人信息子菜单5',
    infoModify: '修改信息',
    infoModify1: '修改信息子菜单1',
    infoModify2: '修改信息子菜单2',
    infoModify3: '修改信息子菜单3',
    fundManage: '资金管理',
    fundList: '资金流水',
    chinaTabsList: '区域投资',
    fundData: '资金数据',
    fundPosition: '投资分布',
    typePosition: '项目分布',
    incomePayPosition: '收支分布',
    permission: '权限设置',
    pagePer: '页面权限',
    directivePer: '按钮权限',
    errorPage: '错误页面',
    page401: '401',
    page404: '404',
    wechatNumber: '微信号'
  },
  index: {
    yearLoss: '年度总盈亏',
    yearProfit: '年度收益率',
    potentialInvestor: '潜在投资人',
    intentionInvestor: '意向投资人',
    waitExamineInvestor: '待审投资人',
    examiningInvestor: '审核中投资人',
    tenMillion: '千万元',
    person: '人'
  }
}

export default zh
